<template>
  <div class="oryzo-header">
    <!-- Nav top -->
    <nav class="oryzo-header__nav">
      <span class="oryzo-header__nav-dot"></span>
      <ul class="oryzo-header__nav-links">
        <li>INTRO</li>
        <li>FEATURES</li>
        <li>PRODUCT</li>
        <li>CONTACT</li>
      </ul>
    </nav>

    <!-- Vertical label right -->
    <div class="oryzo-header__side-label">ORYZO-1 MODEL</div>

    <!-- Top center tagline -->
    <p class="oryzo-header__tagline">MADE FOR MUGS. BUILT FOR TABLES.</p>

    <!-- Hero title -->
    <h1 class="oryzo-header__title">ORYZO</h1>

    <!-- Description right -->
    <p class="oryzo-header__description">
      Designed to lift, insulate, and grip in all<br />
      the right ways. Oryzo makes the<br />
      simplest moment feel considered.
    </p>

    <!-- Bottom left glass card -->
    <div class="oryzo-header__glass-card">
      <p class="oryzo-header__glass-card-top">
        DESIGNED<br />BY LUSION,<br />THE AWARD-WINNING<br />DESIGN STUDIO.
      </p>
      <div class="oryzo-header__glass-card-divider"></div>
      <p class="oryzo-header__glass-card-bottom">
        The world's most<br />unnecessarily<br />sophisticated cork coaster.
      </p>
    </div>

    <!-- Bottom center scroll cue -->
    <div class="oryzo-header__scroll">
      <div class="oryzo-header__scroll-icon">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="9" stroke="white" stroke-width="1.2" />
          <path d="M10 7v6M7 11l3 3 3-3" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <span>SCROLL TO CONTINUE</span>
    </div>

    <!-- Bottom right play thumbnail -->
    <div class="oryzo-header__play-thumb">
      <img src="@/assets/background-image-table.png" alt="Play preview" class="oryzo-header__play-thumb-img" />
      <div class="oryzo-header__play-btn">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <circle cx="9" cy="9" r="8.5" fill="rgba(0,0,0,0.4)" stroke="white" stroke-width="0.8" />
          <polygon points="7,5.5 13.5,9 7,12.5" fill="white" />
        </svg>
        <span>PLAY</span>
      </div>
      <span class="oryzo-header__play-logo">OR<span class="oryzo-header__play-logo-accent">Y</span>ZO</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OryzoHeader',
};
</script>

<style lang="scss" scoped>
.oryzo-header {
  background-image: url('@/assets/background-image-table.png');
  background-size: cover;
  background-position: center;
  height: 560px;
  position: relative;
  overflow: hidden;
  font-family: 'Euclid Circular A', sans-serif;
  color: white;

  // ── Nav ──────────────────────────────────────────────────
  &__nav {
    position: absolute;
    top: 24px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;

    &-dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: white;
    }

    &-links {
      display: flex;
      gap: 32px;
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.08em;
      cursor: pointer;

      li {
        opacity: 0.85;
        transition: opacity 0.2s;

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  // ── Vertical side label ───────────────────────────────────
  &__side-label {
    position: absolute;
    top: 50%;
    right: -56px;
    transform: translateY(-50%) rotate(90deg);
    font-size: 11px;
    letter-spacing: 0.15em;
    font-weight: 500;
    background: white;
    color: #111;
    padding: 6px 16px;
    white-space: nowrap;
  }

  // ── Tagline ───────────────────────────────────────────────
  &__tagline {
    position: absolute;
    top: 36px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.12em;
    white-space: nowrap;
    text-align: center;
  }

  // ── Main title ────────────────────────────────────────────
  &__title {
    position: absolute;
    top: 40px;
    left: -10px;
    font-size: clamp(80px, 14vw, 180px);
    font-weight: 900;
    line-height: 1;
    letter-spacing: -0.02em;
    color: #f5ede0;
    margin: 0;
    user-select: none;
  }

  // ── Description right ────────────────────────────────────
  &__description {
    position: absolute;
    bottom: 26%;
    right: 5%;
    font-size: clamp(16px, 2vw, 24px);
    font-weight: 600;
    line-height: 1.4;
    max-width: 480px;
    text-align: left;
  }

  // ── Glass card bottom-left ────────────────────────────────
  &__glass-card {
    position: absolute;
    bottom: 40px;
    left: 32px;
    width: 260px;
    background: rgba(120, 100, 70, 0.35);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    padding: 20px;
  }

  &__glass-card-top {
    font-size: 13px;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: 0.02em;
    margin: 0 0 12px 0;
    text-align: left;
  }

  &__glass-card-divider {
    border: none;
    border-top: 1px dotted rgba(255, 255, 255, 0.4);
    margin-bottom: 12px;
  }

  &__glass-card-bottom {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
    text-align: right;
    margin: 0;
    color: rgba(255, 255, 255, 0.9);
  }

  // ── Scroll cue ────────────────────────────────────────────
  &__scroll {
    position: absolute;
    bottom: 28px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 10px;
    letter-spacing: 0.15em;
    font-weight: 500;
    opacity: 0.85;
    white-space: nowrap;
  }

  &__scroll-icon {
    flex-shrink: 0;
  }

  // ── Play thumbnail bottom-right ───────────────────────────
  &__play-thumb {
    position: absolute;
    bottom: 24px;
    right: 64px;
    width: 160px;
    height: 90px;
    border-radius: 6px;
    overflow: hidden;
    border: 1.5px solid rgba(255, 200, 100, 0.6);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover .oryzo-header__play-btn {
      transform: translate(-50%, -50%) scale(1.05);
    }
  }

  &__play-thumb-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
  }

  &__play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    transition: transform 0.2s;

    span {
      font-size: 8px;
      letter-spacing: 0.15em;
      font-weight: 600;
    }
  }

  &__play-logo {
    position: absolute;
    bottom: 6px;
    right: 8px;
    font-size: 18px;
    font-weight: 900;
    letter-spacing: -0.02em;
    color: white;
    line-height: 1;
  }

  &__play-logo-accent {
    color: #f5ede0;
  }

  // ── Mobile ────────────────────────────────────────────────
  @media (max-width: 420px) {
    height: 520px;

    &__nav {
      padding: 0 16px;

      &-links {
        gap: 16px;

        li:last-child {
          display: none;
        }
      }
    }

    &__side-label {
      display: none;
    }

    &__tagline {
      font-size: 9px;
      white-space: normal;
      text-align: center;
      width: 60%;
      top: 32px;
    }

    &__title {
      font-size: clamp(64px, 20vw, 90px);
    }

    &__description {
      font-size: 13px;
      font-weight: 500;
      right: auto;
      left: 16px;
      bottom: 18%;
      max-width: 55%;
      line-height: 1.5;
    }

    &__glass-card {
      width: 180px;
      left: 16px;
      bottom: 24px;
      padding: 14px;
    }

    &__glass-card-top {
      font-size: 11px;
    }

    &__glass-card-bottom {
      font-size: 10px;
    }

    &__play-thumb {
      width: 110px;
      height: 65px;
      right: 16px;
      bottom: 24px;
    }

    &__scroll {
      display: none;
    }
  }
}
</style>
